<template>
  <a :href="country === 'AU' ? 'https://forms.gle/32AmjZTQXWQHs5su7' : 'https://dancestudio-pro.com/online/campbelldancers'" target="_blank" class="btn">Enroll</a>
</template>

<script>
export default {
  name: 'EnrollButton',
};
</script>



// WEBPACK FOOTER //
// EnrollButton.vue?324f4012